import Swal from "sweetalert2";
import { domain } from "../../../Urls/Services/Api_urls";
import { showData } from "../../../service/Contrato/showData";
import { showTvCompatibilityModal } from "../../../service/tvCompatibilityMessage";

export const SolicitudLogin = (e) => {
  const isTvCard = Boolean(e?.isTvCard);
  // Componente de modal de compra desde adentro de la app
  const estrato = window.sessionStorage.getItem("estrato");
  const CITI = window.sessionStorage.getItem("city_owner");
  const cdo = window.sessionStorage.getItem("cdo");
  const zone = window.sessionStorage.getItem("zone");
  const adress = window.sessionStorage.getItem("direction");
  const email = window.sessionStorage.getItem("email");
  const cedula = window.sessionStorage.getItem("cedula");
  const celular = window.sessionStorage.getItem("phone");
  const name = window.sessionStorage.getItem("namedas");
  const last_name = window.sessionStorage.getItem("last_name");
  const token = window.sessionStorage.getItem("token");
  const localization = window.sessionStorage.getItem("localization");
  const METODO = "GET";
  console.log(e);
  const precio = e.precio_persona;
  let typedoc = [];
  let mess = "";
  let valor_plan = "";
  let tarifa_plena = "";
  if (e.descuento !== undefined && e.descuento !== null && e.descuento !== '') {
    valor_plan = parseInt(e.descuento_valor[e.estrato]);
    console.log("no entiendo cual es el valor de e",e)
    tarifa_plena = e.precio_persona[e.estrato];
  } else {
    valor_plan = parseInt(precio[e.estrato]);
  }
  // console.log(e.descuento_valor[e.estrato]);

  let observacionesTexto = "";

  const meses = e.meses ?? e.months ?? null;
  const discountMonths = e.discount_months ?? null;

  if (e.descuento) {
    const hasMegas = e.megas && e.megas !== 0;
    const megasText = hasMegas ? ` y ${e.megas} MB adicionales` : '';
    
    // Verificar si discount_months es diferente a months
    if (discountMonths && meses && discountMonths !== meses) {
      // Caso 1: discount_months diferente a months
      observacionesTexto = `Aplica ${e.descuento}% de descuento por ${meses} meses${megasText}\npor ${discountMonths} meses. Posteriormente, se aplicará la tarifa plena\nvigente de ${new Intl.NumberFormat("es-CO", {
        style: "currency",
        currency: "COP",
        minimumFractionDigits: 0,
      }).format(Math.trunc(tarifa_plena))} y las megas contratadas.`;
    } else {
      // Caso 2: discount_months igual a months (o no definido)
      observacionesTexto = `Aplica ${e.descuento}% de descuento${megasText} por ${meses} meses.\nPosteriormente, se aplicará la tarifa plena vigente de ${new Intl.NumberFormat("es-CO", {
        style: "currency",
        currency: "COP",
        minimumFractionDigits: 0,
      }).format(Math.trunc(tarifa_plena))}.`;
    }
  } else {
    observacionesTexto = "No aplica descuento.";
  }

  const resultinfoPromise = showData(
    METODO,
    token,
    "/api/identification_types/"
  );
  resultinfoPromise.then((resultinfo) => {
    typedoc = resultinfo.data; // Aquí puedes acceder a los datos devueltos por el fetch
  });

  console.log(typedoc);

  const campoArchivo = (inputId) => `
        <style>.btn-archivo{background-color:#e9ecef;color:#212529;border:1px solid #ced4da;border-radius:.375rem 0 0 .375rem;}.btn-archivo:hover:not(:disabled){background-color:#d3d9df;color:#212529;}.btn-archivo:focus-visible,.btn-archivo:active{background-color:#e9ecef;color:#212529;border-color:#ced4da;}</style>
        <input id="${inputId}" type="file" style="display:none">
        <div class="input-group">
            <button type="button" class="btn btn-archivo" id="${inputId}-cargar">Cargar archivo</button>
            <div class="form-control" id="${inputId}-nombre" style="text-align:left; overflow:hidden; text-overflow:ellipsis; white-space:nowrap;">
                <span style="color:#6c757d">Seleccionar archivo</span>
            </div>
        </div>`;

  const showSolicitudServicioModal = () => {
    Swal.fire({
      title: "Solicitar Servicio",
    html:
      `
                <form>
                <div class="m-3">
                    <div class="row mb-3">
                    <div class="col-6 mb-3">
                    <label for="NameLabelUpdate" class="labelFount">Propietario Nombre</label>
                    <input type="text" id="swal-input1" class="form-control" placeholder="Propietario" value="` +
      name +
      `">
                </div>
                <div class="col-6 mb-3">
                      <label for="NameLabelUpdate" class="labelFount">Propietario Apellido</label>
                      <input type="text" id="swal-input10" class="form-control" placeholder="Propietario" value="` +
      last_name +
      `">
                  </div>
                  <div class="mb-3" >
                <label for="NameLabelUpdate" class="labelFount">Tipo de documento</label>
                <div class="" style="display: flex; justifyContent: center; ">
                <select class="select" id="status" style="width: 100%; height: 2.4rem; border: 0.5px solid #E0E0E0; border-radius:4px; background-color: #fff; padding: 0.5rem;">
                  <option value="2">Cedula de Ciudadania</option>
                  <option value="3">NIT</option>
                  <option value="4">Tarj de Identidad</option>
                  <option value="5">Registro Civil</option>
                  <option value="6">Ced de Extrageria</option>
                  <option value="7">Pasaporte</option>
                  <option value="8">NUIP</option>
                  <option value="9">Codigo DANE</option>
                </select>
                </div>
              </div>
                        <div class="col-12">
                            <label for="NameLabelUpdate" class="labelFount">Documento</label>
                            <input ${cedula ? 'disabled' : ''} type="number" id="swal-input2" class="form-control" placeholder="DNI Propietario" value="` +
      cedula +
      `">
                        </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-12">
                          <label for="NameLabelUpdate" class="labelFount" style="margin-top: 1rem;">Celular</label>
                          <input type="number" id="swal-input3" class="form-control" placeholder="CEL Propietario" value="` +
      celular +
      `">
                      </div>
                      
                    </div>
                    <div class="col-12">
                          <label for="NameLabelUpdate" class="labelFount">Correo propietario</label>
                          <input disabled type="email" id="swal-input5" class="form-control" placeholder="Correo propietario" value="` +
      email +
      `">
                      </div>
                    </div>
                    <div class="mb-4">
                        <label for="NameLabelUpdate" class="labelFount">Adjuntar recibo publico</label>
                        ` +
      campoArchivo("swal-input6") +
      `
                    </div>
                    <div class="mb-4">
                        <label for="NameLabelUpdate" class="labelFount">Adjuntar Cedula cara frontal</label>
                        ` +
      campoArchivo("swal-input7") +
      `
                    </div>
                    <div class="mb-4">
                        <label for="NameLabelUpdate" class="labelFount">Adjuntar Cedula cara posterior</label>
                        ` +
      campoArchivo("swal-input8") +
      `
                    </div>
                    <div class="mb-4">
                        <label for="NameLabelUpdate" class="labelFount">Plan</label>
                        <h5>` +
      e.nombreplan +
      `</h5>
                        <h5>$` +
                        valor_plan +
      `</h5>
                    </div>
    
                    <div class="row mb-4">
                      <label for="NameLabelUpdate" class="labelFount">Observaciones</label>
                      <textarea id="swal-input9" class="form-control" rows="5" placeholder="Para hacer saltos de linea presionar ENTER" >${observacionesTexto}</textarea>
                    </div>
                </div>
            </form>
          `,
    confirmButtonText: "Comprar",
    cancelButtonText: "Cancelar",
    confirmButtonColor: "#655CC9",
    showCancelButton: true,
    focusConfirm: false,
    showCloseButton: true,
    allowOutsideClick: false,
    allowEscapeKey: false,
    didOpen: () => {
      ["swal-input6", "swal-input7", "swal-input8"].forEach((id) => {
        const input = document.getElementById(id);
        const nombre = document.getElementById(`${id}-nombre`);
        document.getElementById(`${id}-cargar`).addEventListener("click", () => input.click());
        input.addEventListener("change", () => {
          if (input.files[0]) nombre.textContent = input.files[0].name;
        });
      });
    },
    preConfirm: () => {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);

      var formdata = new FormData();
      formdata.append("address", adress);
      formdata.append("name", document.getElementById("swal-input1").value);
      formdata.append(
        "last_name",
        document.getElementById("swal-input10").value
      );
      formdata.append("type_ide", document.getElementById("status").value);
      formdata.append("cc", document.getElementById("swal-input2").value);
      formdata.append(
        "contact_phone",
        document.getElementById("swal-input3").value
      );

      formdata.append(
        "email_owner",
        document.getElementById("swal-input5").value
      );

      formdata.append("estrato", estrato);
      formdata.append("city_owner", CITI);
      formdata.append("price_plan", valor_plan);
      formdata.append("ad_cc", document.getElementById("swal-input7").files[0]);
      formdata.append(
        "ad_cc_back",
        document.getElementById("swal-input8").files[0]
      );
      formdata.append("category", "Residencial");
      formdata.append(
        "rec_pub",
        document.getElementById("swal-input6").files[0]
      );
      formdata.append("plan", e.nombreplan);
      formdata.append(
        "observations",
        document.getElementById("swal-input9").value
      );
      formdata.append("cdo", cdo);
      formdata.append("zone", zone);
      formdata.append("id_plan", e.id__planes);
      formdata.append("plan_type", e.tipoplan);
      formdata.append("id_plan_open", e.codigo_open);
      formdata.append("localization", localization);

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };
      // {"status":400,"type":"error","msg":"This QueryDict instance is immutable"}
      return fetch(domain + "/portal/", requestOptions)
        .then(async (response) => {
          let errorMsg = "";
          if (!response.ok) {
            const responseBody = await response.text();

            try {
              errorMsg = JSON.parse(responseBody);

              if (errorMsg.msg) {
                let htmlMessage = "<div style='display: flex; flex-direction: column;'>";
                htmlMessage += "<ul>";
              
                for (let key in errorMsg.msg) {
                  if (errorMsg.msg.hasOwnProperty(key)) {
                    const errorDetails = Array.isArray(errorMsg.msg[key])
                      ? errorMsg.msg[key].join(", ")
                      : errorMsg.msg[key];
                    htmlMessage += `<li><strong>${key}:</strong> ${errorDetails}</li>`;
                  }
                }
              
                htmlMessage += "</ul></div>";
              
                Swal.showValidationMessage(htmlMessage);
              }
              
            } catch (error) {

              throw new Error(
                `${mess}`
              );
            }
          } else {
            Swal.fire({
              title: "Registro exitoso",
              text: "Firma tu contrato en el apartado solicitudes",
              icon: "success",
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Ver solicitud",
              // timer: 4000,
            }).then((result) => {
              if (result.isConfirmed) {
                sessionStorage.getItem("groups") === "Usuario"
                  ? (window.location.href = "/Solicitud/[S,C,N,O,NA]")
                  : (window.location.href = "/Solicitud/[S,C,NA]");
              }
            });
          }
        })
        .catch((error) => {
          Swal.showValidationMessage(`${error.message}`);
        });
    },
    });
  };

  if (isTvCard) {
    showTvCompatibilityModal(e.nombreplan, showSolicitudServicioModal);
  } else {
    showSolicitudServicioModal();
  }
};

// ## Summary
// This code defines a function named `SolicitudLogin` that is used to handle a login request. It displays a form using the Swal library, collects user input, and sends a POST request to a specified API endpoint.

// ## Example Usage
// ```javascript
// SolicitudLogin({descuento: null, precio_persona: 100, nombreplan: "Plan A", id__planes: 1, tipoplan: "Tipo A", codigo_open: "ABC123"});
// ```
// This code will trigger the `SolicitudLogin` function and display a Swal modal with a form. The form will be pre-filled with some data and the user can enter additional information. When the user clicks the "Comprar" button, a POST request will be sent to the API endpoint with the form data.

// ## Code Analysis
// ### Inputs
// - `e` (object): An object containing information about the plan, such as discount, price, name, ID, and type.
// ___
// ### Flow
// 1. Retrieve various data from the window.sessionStorage object.
// 2. Determine the price based on the presence of a discount.
// 3. Display a Swal modal with a form, pre-filled with some data.
// 4. Collect user input from the form.
// 5. Create a FormData object and append the collected data.
// 6. Send a POST request to the specified API endpoint with the form data.
// 7. Handle the response from the API:
//    - If the response is not successful, display an error message.
//    - If the response is successful, display a success message and redirect the user to a specific page.
// ___
// ### Outputs
// - None. The function performs actions based on user input and API response.
// ___
